import React from 'react';
import "./styles.css";

/**
 * @function DisputeTransactionDetailsWidget
 * @return {React.Component}
 * @exported true
 * @description Shows the details of the disputed transaction
 */

export default function DisputeTransactionDetailsWidget(props) {
  const dispute = props.dispute ?? {};
  const hasDispute = props.dispute ? true : false;
  let disputeAmount = hasDispute ? dispute.transaction.amount.format() : "";
  const transactionDate = hasDispute ? dispute.transaction.purchaseDate.format("M d, Y") : "";
  const hasPartialDisputeAmount = dispute.howMuchOfTheTransactionAmountAreYouDisputing === "partial";
  disputeAmount = hasPartialDisputeAmount ? dispute.partialDisputeAmount.format() : disputeAmount;

  return(
    <div className="dispute-transaction-details-widget">
        <div className="flex-container flex-vertical align-center-container">
          <div className="detail-item text-center">
            <p>Confirmation Number</p>
            <p className="sub-text">{ dispute.confirmationNumber }</p>
          </div>
          <div className="detail-item text-center">
            <p>Merchant Description</p>
            <p className="sub-text">{ hasDispute ? dispute.transaction.merchant.description : "" }</p>
          </div>
          <div className="detail-item text-center">
            <p>Transaction Amount</p>
            <p className="sub-text">{ hasDispute ? dispute.transaction.amount.format() : "" }</p>
          </div>
          <div className="detail-item text-center">
            <p>Dispute Amount</p>
            <p className="sub-text">{ disputeAmount }</p>
          </div>
          <div className="detail-item text-center">
            <p>Transaction Date</p>
            <p className="sub-text">{ transactionDate }</p>
          </div>
          <div className="detail-item text-center">
            <p>Submit Date</p>
            <p className="sub-text">{ hasDispute ? dispute.submissionDate.format("M d, Y") : "" }</p>
          </div>
          {/* Removing this info since its not show in ch21. */}
          {/*<div className="detail-item text-center">
            <p>Dispute Submit Date</p>
            <p className="sub-text">[[MMMM DD, YYYY]]</p>
          </div>*/}
          {/*<div className="detail-item text-center">
            <p>Reason</p>
            <p className="sub-text">[[Reason]]</p>
          </div>*/}
          {/*<div className="detail-item text-center">
            <p>Additional Comments</p>
            <p className="sub-text">[[Comments]]</p>
          </div>*/}
        </div>
    </div>
  );
}